import moment from 'moment'

export const currencyFT = {
  name: 'currencyFT',
  value: function(v, precision) {
    if (!v) return '-'
    const integer = String(v).split('.')[0]
    let float = String(v).split('.')[1]
    float = float ? float.substring(0, precision || 0) : Array(precision).fill('0').join('')
    const right = float ? '.' + float : ''
    return integer.split('').reverse().join('').replace(/\d{3}(?=\d{1})/g, '$&,').split('').reverse().join('') + right
  }
}

export const timeFT = {
  name: 'timeFT',
  value: function(v) {
    if (!v) return '-'
    return moment(v).format('yyyy-MM-DD HH:mm:ss')
  }
}

export const dateFT = {
  name: 'dateFT',
  value: function(v) {
    if (!v) return '-'
    return moment(v).format('yyyy-MM-DD')
  }
}

export const commonFT = {
  name: 'commonFT',
  value: function(v, data) {
    if (!v && v !== 0) return '-'
    const map = data.filter(x => x.value === v)[0]
    return map ? (map.name || '-') : '-'
  }
}

export const phoneFT = {
  name: 'phoneFT',
  value: function(phone, data) {
    if (!phone ) return ''
    return phone.replace(/^(\d{3})\d{4}(\d+)/, '$1****$2');
  }
}

export const numberFT = {
  name: 'numberFT',
  value: function(number, data) {
    if (!number ) return '0'
    return number.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
  }
}

export default [
  timeFT,
  dateFT,
  currencyFT,
  commonFT,
  phoneFT,
  numberFT
]



// WEBPACK FOOTER //
// ./src/filter/index.js